import {forwardRef, useCallback} from "react";

// --- Hooks ---
import {useTiptapEditor} from "components/RichEditor/hooks/use-tiptap-editor";

// --- UI ---
import {Button} from "components/RichEditor/components/tiptap-ui-primitive/button";
import {CheckboxChecked} from "components/RichEditor/components/tiptap-icons/checkbox-checked-icon";

export const CheckboxButton = forwardRef(
  ({editor: providedEditor, onClick, ...props}, ref) => {
    const {editor} = useTiptapEditor(providedEditor);

    const handleClick = useCallback(
      (e) => {
        onClick?.(e);
        if (e.defaultPrevented) return;

        editor?.chain().focus().insertCheckbox(false).run();
      },
      [editor, onClick]
    );

    if (!editor) return null;

    return (
      <Button
        type="button"
        variant="ghost"
        tooltip="RICH_EDITOR_TOOLBAR_CHECKBOX_BUTTON_TOOLTIP"
        onClick={handleClick}
        ref={ref}
        {...props}
      >
        <CheckboxChecked width="18px" height="18px" />
      </Button>
    );
  }
);
